import * as React from "react";
import styled from "styled-components";
import Header from "../components/header/index";
import LeftText from "../components/laEmpresa/leftText";
import RightText from "../components/laEmpresa/rightText";
import SeguroParaTodos from "../components/footer/seguroParaTodo";
import Footer from "../components/footer/index";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--white);
  overflow: hidden;
`;

export default function Terminos() {
  return (
    <Container>
      {/* Header */}
      <Header></Header>
      {/* Principal Title and Quienes somos */}
      <LeftText
        title="Términos y Condiciones"
        subTitle="SeguroBici"
        text={[
          "Recomendamos que lea los Términos de Uso del sitio segurobici.com.ar antes de su uso, ya que la utilización frecuente y continuada del mismo representará la aceptación de los términos. Estas condiciones del sitio segurobici.com.ar (de aquí en más, “el sitio”) así como las ",
          <a href="/privacidad">Políticas de Privacidad</a>,
          " pueden ser modificadas por el mismo sin necesidad de aviso ni divulgación del hecho, por lo que es prudente que usted revise esta landing con asiduidad para estar al tanto de las actualizaciones. En caso de no coincidir con los términos de uso o con fragmentos de ellos, le recomendamos no continuar en el sitio.",
        ]}
        image="images/nosotros/ilustration1.svg"
      ></LeftText>
      {/* Nuestros Objetivos */}
      <RightText
        subTitle="Sobre el producto ofrecido"
        text={[
          "La información, valores y alcances de nuestros productos mostrados en el sitio están sujetos a posibles cambios relacionados con aéreas geográficas, casos extraordinarios y cuestiones personales del cliente. Los términos y condiciones informados en el sitio para cada producto de por SeguroBici marca de Gestión y Servicios S.R.L. son a nivel general y puede que no todas las condiciones, aplicaciones, excepciones y beneficios estén plasmados.",
          <br></br>,
          <br></br>,
          "Todo lo mostrado en el sitio está disponible en las jurisdicciones en las que está presente segurobici.com.ar con su correspondiente matrícula emitida por la Superintendencia de Seguros de la Nación.",
          <br></br>,
          <br></br>,
          "Gestión y Servicios S.R.L. no garantiza que: el sitio segurobici.com.ar funcione ininterrumpidamente y en forma correcta ni que los errores visualizados sean corregidos, la navegación en el sitio segurobici.com.ar, el uso del servidor o los correos electrónicos enviados desde un dominio propio estén exentos de virus o software malicioso, el sitio segurobici.com.ar ofrezca productos o servicios que estén disponibles para usted o que las funciones del sitio sean utilizables por usted en la jurisdicción geográfica en que se encuentre.",
          <br></br>,
          <br></br>,
          "Al realizar una cotización online en el sitio y dejar sus datos correspondientes a dirección de email o número telefónico, usted está aceptando unirse a nuestra base de datos y esa información personal puede utilizarse por SeguroBici marca de Gestión y Servicios S.R.L. para fines comerciales. A la vez, SeguroBici marca de Gestión y Servicios S.R.L. se compromete a no usar esa información para otras finalidades y a no vender, intercambiar, ceder o hacer públicos esos datos.",
        ]}
        image="images/nosotros/ilustration2.svg"
      ></RightText>
      {/* Visión Comercial */}
      <LeftText
        subTitle="Responsabilidad Limitada"
        text="segurobici.com.ar se desliga de toda responsabilidad ante lesiones, reclamos, daños o acciones surgidos de: el accionar del sitio, los materiales del sitio o la imposibilidad de acceso al mismo y lo mismo para sitios de terceros vinculados con segurobici.com.ar; errores, virus digitales, omisiones o fallas generadas desde el sitio, excepto negligencia grave y concreta de segurobici.com.ar."
        image="images/nosotros/ilustration1.svg"
      ></LeftText>
      {/* ¿Qué hemos logrado? */}
      <RightText
        subTitle="Jurisdicción"
        text={[
          "Los términos y condiciones aquí presentados están regidos por y siguen las leyes de la República Argentina y fueron redactados en base a lo establecido por la misma. Esto no implica que no pueda haber conflictos, desacuerdos, interpretaciones diferentes u opiniones variadas de estos términos, en cuyos casos el usuario deberá comunicarse de manera fehaciente con SeguroBici marca de Gestión y Servicios S.R.L. (Suipacha 245 6º piso, Capital Federal; teléfono: 011 4328 6757; dirección de email: ",
          <a href="mailto:info@gyssrl.com.ar">info@gyssrl.com.ar</a>,
          "). Si aún así persistiera el conflicto, tanto estos términos y condiciones como la compañía en sí están dispuestos a ser sometidos a los Tribunales correspondientes.",
        ]}
        image="images/nosotros/ilustration2.svg"
      ></RightText>
      {/* Seguros para todos */}
      <SeguroParaTodos></SeguroParaTodos>
      {/* Footer */}
      <Footer></Footer>
    </Container>
  );
}
